
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'

    import backStoreAgeRuleModel from '@/store/entities/back-store-age-rule'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';


    @Component
    export default class EditBackStoreAgeRule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        formData: backStoreAgeRuleModel = new backStoreAgeRuleModel();


        priceColumns = [
            {
                title: '最小值(包含)',
                key: 'begin',
                render: (h: any, params: any) => {
                    return h('div', [h('h3', ">=" + params.row.begin+"天")])
                }
            },
            {
                title: '最大值(包含)',
                key: 'end',
                render: (h: any, params: any) => {
                    return h('div', [h('h3', "<=" + params.row.end + "天")])
                }
            },
            {
                title: '单价(m?/天)积分',
                key: 'cose',
                render: (h, params) => {
                    var _this = this;
                    return h('InputNumber', {
                        props: {
                            value: params.row.cost,
                            min: 0,
                            precision: 0
                        },
                        style: {
                            width: '120px'
                        },
                        on: {
                            'on-change': (value) => {
                                this.setCost(params.index, value);
                            }
                        }
                    });
                }
            },
            {
                title: '费用上限(非必填)积分',
                key: 'maxCost',
                render: (h, params) => {
                    var _this = this;
                    return h('InputNumber', {
                        props: {
                            value: params.row.maxCost,
                            min: 0,
                            precision: 0
                        },
                        style: {
                            width: '120px'
                        },
                        on: {
                            'on-change': (value) => {
                                this.setMaxCost(params.index, value);
                            }
                        }
                    });
                }
            }
        ];

        created() {

        }

        async save() {
            var title = '修改规则';
            if (this.formData.id == 0) {
                title = "新增规则";
            }
            this.$Modal.confirm({
                title: title, content: "确定" + title+"？", onOk: async () => {
                    await this.$store.dispatch({
                        type: 'backStockAgeRules/edit',
                        data: this.formData
                    });
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            });

        }

        async setCost(index, value) {
            this.formData.items[index].cost = value;
        }

        async setMaxCost(index, value) {
            this.formData.items[index].maxCost = value;
        }

        cancel() {
            this.$emit('input', false);
        }

        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                this.formData = this.$store.state.backStockAgeRules.model;
            }
        }
    }
